<div class="frozen-columns">
  <ng-template *ngTemplateOutlet="headerSelectionTemplate"></ng-template>
  <div class="item-header-cell">Item</div>
</div>
<cc-tool-tip contentKey="list-item-colour-explainer">
  <div class="list-header-property list-style-property">Colour</div>
</cc-tool-tip>
<ng-container *ngIf="listProperties">
  <cc-list-header-property
    *ngFor="
      let _ of beforeAddPropertyIterator;
      index as index;
      trackBy: this.trackByBeforeAddPropertyColumn.bind(this)
    "
    [index]="index"
    [isLast]="false"
    (onPropertyMoved)="onPropertyMove($event)"
    (onRequestAddProperty)="onStartAddProperty($event)"
    [property]="listProperties[index]"
    [editable]="!isDeployedList && canEditProperties"
    [users]="users"
    (propertyChanged)="onPropertyChange($event)"
    (propertyDeleted)="onListPropertyDeleted($event)"
    [isUpgradeModalVisible]="isUpgradeModalVisible"
    [hasReachedPlanLimit]="hasReachedPlanLimit"
  ></cc-list-header-property>

  <cc-list-property-add
    *ngIf="addPropertyIndex !== null && canEditProperties"
    (propertyCreated)="onPropertyAddedInBetween($event)"
    (propertyCancelled)="onCancelPropertyAdd()"
    data-test="add-property-in-between"
    [listId]="listId"
    [addIndex]="addPropertyIndex"
    [listProperties]="listProperties"
    [parentId]="parentId"
    [hierarchy]="hierarchy"
    [hasReachedPlanLimit]="hasReachedPlanLimit"
    [isUpgradeModalVisible]="isUpgradeModalVisible"
    [hasReachedPlanLimit]="hasReachedPlanLimit"
    [isInCreateMode]="isInCreatePropertyMode"
  >
  </cc-list-property-add>

  <cc-list-header-property
    *ngFor="
      let _ of afterAddPropertyIterator;
      index as index;
      last as last;
      trackBy: this.trackByAfterAddPropertyColumn.bind(this)
    "
    [index]="index + addPropertyIndex"
    [isLast]="last"
    (onPropertyMoved)="onPropertyMove($event)"
    (onRequestAddProperty)="onStartAddProperty($event)"
    [property]="listProperties[index + addPropertyIndex]"
    [editable]="!isDeployedList && canEditProperties"
    [users]="users"
    (propertyChanged)="onPropertyChange($event)"
    (propertyDeleted)="onPropertyDelete($event)"
    [isUpgradeModalVisible]="isUpgradeModalVisible"
    [hasReachedPlanLimit]="hasReachedPlanLimit"
  ></cc-list-header-property>
</ng-container>

<cc-list-property-add
  *ngIf="!isDeployedList && canEditProperties"
  (propertyCreated)="onPropertyCreate($event)"
  (propertyCancelled)="onCancelPropertyAdd($event)"
  (startCreateMode)="onStartAddProperty()"
  [listId]="listId"
  [listProperties]="listProperties"
  [parentId]="parentId"
  [hierarchy]="hierarchy"
  [hasReachedPlanLimit]="hasReachedPlanLimit"
  [isUpgradeModalVisible]="isUpgradeModalVisible"
  [planType]="planType"
  [isInCreateMode]="isInCreatePropertyMode && addPropertyIndex === null"
  #addListProperty
>
</cc-list-property-add>

<ng-template #headerSelectionTemplate>
  <div class="list-item-action-cell list-header-cell">
    <cc-popover placement="right" *ngIf="!isDeployedList || canEditProperties">
      <span content>
        {{ itemCount > 0 && itemCount === selectedItemCount ? 'Deselect All' : 'Select All' }}
      </span>
      <button
        trigger
        type="button"
        class="list-selection-checkbox"
        aria-role="checkbox"
        data-test="select-all-items"
        (click)="onToggleSelectAll()"
        [disabled]="itemCount === 0"
        [attr.aria-checked]="itemCount > 0 && itemCount === selectedItemCount"
      >
        <i class="cc-icon cc-icon-check cc-icon-sm" aria-hidden="true"></i>
      </button>
    </cc-popover>
  </div>
</ng-template>
